import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";

export default class extends Controller {
  connect() {
    this.initDataTable();
  }

  initDataTable() {
    // Only initialize on table
    if (!$.fn.DataTable.isDataTable(this.element)) {
      $(this.element).DataTable({
        responsive: true,
        pageLength: 10,
        lengthMenu: [5, 10, 25, 50, 100],
        order: [[1, "asc"]],
        dom:
          "<'row mb-3'<'col-sm-6'l><'col-sm-6 text-end'B>>" +
          "<'row'<'col-12'tr>>" +
          "<'row mt-3'<'col-sm-5'i><'col-sm-7'p>>",
        buttons: [
          {
            extend: "excelHtml5",
            text: '<i class="bi bi-file-earmark-excel"></i> Export Excel',
            className: "btn btn-outline-success btn-sm me-2 rounded-pill shadow-sm",
          },
          {
            extend: "csvHtml5",
            text: '<i class="bi bi-filetype-csv"></i> Export CSV',
            className: "btn btn-outline-primary btn-sm me-2 rounded-pill shadow-sm",
          },
          {
            extend: "print",
            text: '<i class="bi bi-printer"></i> Print',
            className: "btn btn-outline-secondary btn-sm rounded-pill shadow-sm",
          },
        ],
        language: {
          searchPlaceholder: "Search projects...",
          search: "",
          lengthMenu: "Show _MENU_ entries",
        },
      });
    }
  }
}
